import type {Nullable} from '@nib/types-session-api';
import {Action} from '../../actions';
import {FailedRequestPayload, AxiosError} from '../types';

const FETCH_PRODUCT_PACKAGE_PRICES = 'product-packages/prices/fetch';

export const ActionTypes = {
  FETCH_PRODUCT_PACKAGE_PRICES_PENDING: `${FETCH_PRODUCT_PACKAGE_PRICES}_PENDING`,
  FETCH_PRODUCT_PACKAGE_PRICES_FULFILLED: `${FETCH_PRODUCT_PACKAGE_PRICES}_FULFILLED`,
  FETCH_PRODUCT_PACKAGE_PRICES_REJECTED: `${FETCH_PRODUCT_PACKAGE_PRICES}_REJECTED`
};

export interface PricingStatusState {
  loadingPrice?: boolean;
  loadingBatchPrice?: boolean;
  fetchedPrice?: boolean;
  priceError?: AxiosError | null;
}

export interface ProductPrice {
  price: number;
  futurePrice?: number;
}

export interface Products {
  hospital: number[];
  extras: number[];
  rules: any[];
  productVariations: ProductVariation[];
}

export interface ProductVariation {
  hospital: number[];
  extras: number[];
  variationId?: string;
}

export interface PricingState extends PricingStatusState {
  totalPrice: number;
  products: PricingProduct[];
  productsList?: ProductsList[];
}

export interface ProductsList {
  total?: number;
  products?: PricingProduct[];
}

export interface SetProductNamePayload {
  productName: string;
}

export interface FetchPricePayload {
  dob: string;
  partnerDob: string;
  dateJoinedFund: string;
  effectiveDate: string;
  startDate: string;
  endDate: string;
  gender: string;
  paymentFrequency: string;
  rate: number;
  scale: string;
  hospitalProduct: number;
  extrasProduct?: number;
  excess?: string;
  numberOfChildren?: number;
  source?: Nullable<string>;
}

export interface FetchPriceFulfilledPayload {
  total: number;
  products: PricingProduct[];
}

export interface PricingProduct {
  productType: string;
  baseRate: number;
  price: number;
  risk: number;
  productCode: number;
}

export interface FetchPricesFulfilledPayload {
  status: string;
  data: [
    {
      total: number;
      products: PricingProduct[];
    }
  ];
  errors: [];
}

interface SetNameAction extends Action<SetProductNamePayload> {
  type: string;
  payload: SetProductNamePayload;
}

interface FetchPriceAction extends Action<FetchPricePayload> {
  type: string;
  payload: FetchPricePayload;
}

interface FetchPriceFulfilledAction extends Action<FetchPriceFulfilledPayload> {
  type: string;
  payload: FetchPriceFulfilledPayload;
}

interface FetchPriceRejectedAction extends Action<FailedRequestPayload> {
  type: string;
  payload: FailedRequestPayload;
}

export type PricingActionTypes = FetchPriceAction | FetchPriceFulfilledAction | FetchPriceRejectedAction | SetNameAction;
